import { TranslationContext } from 'contexts/translation-context';
import styled from 'styled-components';
import { useEffect, useState, useContext } from 'react';
import { Typography, Link, Box, Checkbox, FormControlLabel } from '@mui/material';
import { FormikProps } from 'formik';
import { JoinFormType } from 'types/join';

const TitleText = styled(Typography)(() => ({
  fontWeight: 'bold'
}));

const Text = styled(Typography)(() => ({
  marginBottom: '11px'
}));

const StyledLink = styled(Link)(() => ({
  color: '#9B9B9B',
  textDecoration: 'underline',
  textDecorationColor: '#9B9B9B',
  '&:hover': {
    textDecoration: 'underline',
    textDecorationColor: '#9B9B9B'
  }
}));

const Subscribe = styled.div`
  font-family: ${props => props.theme.fonts.montserratMedium};
  font-size: 13px;
  color: #434343;
  margin-left: 9px;
`;

const CheckboxContainer = styled.div`
  margin-top: -4px;
  margin-left: 12px;
`;

const StyledCheckbox = styled(Checkbox)`
  padding: 2px;
  && {
    & .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
    }
    & .MuiFormControlLabel-label {
      font-family: 'Montserrat-Medium', sans-serif;
      font-size: 11px;
      display: flex;
      align-items: center;
    }
  }
`;

const StyleToggle = styled.div`
  color: ${props => props.theme.colors.siteBlue};
  text-decoration: underline;
  margin-top: 2px;
  cursor: pointer;
  font-size: 13px;
  font-family: 'Montserrat-Medium', sans-serif;
`;

export const SmsTermsMoreDetailsContent = ({
  form,
  disabled = false
}: {
  form: FormikProps<JoinFormType>;
  disabled: boolean;
}) => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  const [showMoreDetails, setShowMoreDetails] = useState(false);

  const toggleMoreDetails = () => {
    setShowMoreDetails(!showMoreDetails);
  };

  return (
    <CheckboxContainer>
      <div style={{ display: 'flex' }}>
        <FormControlLabel
          label={<Subscribe>{TRANSLATION_TEXT.agree_to_receive_texts_per_the_sms_terms}</Subscribe>}
          control={
            <StyledCheckbox
              disabled={disabled}
              checked={form.values.smsTerms}
              onChange={() => {
                form.setFieldValue('smsTerms', !form.values.smsTerms);
              }}
              color="primary"
            />
          }
        />

        {/* {anyAdditionalChecked && !subscribeToNewsletters && <span>-</span>} */}
        <StyleToggle onClick={toggleMoreDetails}>
          {showMoreDetails ? 'Less Details' : 'More Details'}
        </StyleToggle>
      </div>
      {showMoreDetails && (
        <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3, color: '#9B9B9B' }}>
          <TitleText variant="h6">{TRANSLATION_TEXT.program_description_title}</TitleText>
          <Text variant="body2" paragraph>
            {TRANSLATION_TEXT.program_description}
          </Text>

          <TitleText variant="h6">{TRANSLATION_TEXT.cost}</TitleText>
          <Text variant="body2" paragraph>
            {TRANSLATION_TEXT.cost_description}
          </Text>

          <TitleText variant="h6">{TRANSLATION_TEXT.message_frequency_title}</TitleText>
          <Text variant="body2" paragraph>
            {TRANSLATION_TEXT.message_frequency_description}
          </Text>

          <TitleText variant="h6">{TRANSLATION_TEXT.how_to_opt_out_title}</TitleText>
          <Text variant="body2" paragraph>
            {TRANSLATION_TEXT.how_to_opt_out_description}
          </Text>

          <TitleText variant="h6">{TRANSLATION_TEXT.support_or_help_title}</TitleText>
          <Text variant="body2">
            {TRANSLATION_TEXT.support_or_help_description}{' '}
            <StyledLink
              href="https://www.rapnet.com/contact/support/"
              underline="always"
              target="_blank"
              rel="noopener noreferrer"
            >
              {TRANSLATION_TEXT.contact_us}
            </StyledLink>
            .
          </Text>
        </Box>
      )}
    </CheckboxContainer>
  );
};

export default SmsTermsMoreDetailsContent;
